import {defineMessages} from 'react-intl'

export default defineMessages({
    startChat: {id: 'containers.ProjectPage.components.ProjectContact.startChat', defaultMessage: "Start chat"},
    prompt: {
        id: 'containers.ProjectPage.components.ProjectContact.prompt',
        defaultMessage: "I'm here to help you pick the right voice."
    }
})
